'use client'

import useControl from '@component/mapbox/control/useControl'
import { useEffect, useMemo, useState } from 'react'
import dynamic from 'next/dynamic'
import { HOUSE_TYPE_ID } from '@config'
import AboutAreaMenuControlContext from './context'
import AboutAreaMenu from './menu'
import { useMapboxContext } from '@component/mapbox/map/context'
import { useAboutAreaContext } from '../context'
import classNames from 'classnames'
const AboutAreaCommute = dynamic(() => import('./content/commute'), { ssr: false })
const AboutAreaSchool = dynamic(() => import('./content/school'), { ssr: false })
const AboutAreaUnitaryPlan = dynamic(() => import('./content/unitaryPlan'), { ssr: false })
const AboutAreaServices = dynamic(() => import('./content/services'), { ssr: false })
const AboutAreaContour = dynamic(() => import('./content/contour'), { ssr: false })
const AboutAreaFlood = dynamic(() => import('./content/flood'), { ssr: false })
const AboutAreaStatistics = dynamic(() => import('./content/statistics'), { ssr: false })

export default function AboutAreaMenuControl({
  ...args
}) {
  return useControl(<MenuControlContent {...args}></MenuControlContent>, { position: 'top-left', groupClass: false })
}

// menu type
export const MENU_ITEM_TYPE = {
  school: 1,
  commute: 2,
  statistics: 3,
  // recentSold: 4,
  unitaryPlan: 5,
  services: 6,
  contour: 7,
  flood: 8
}
// menu control
export function MenuControlContent({
  // 是否包含人口统计数据(Statistics模块)
  hasCensus,
  // 用来判断是否显示(Unitary plan Zone, Underground services, Flood assessment, Contours)
  regionId,
  // 用来判断房源类型(isRural，和Flood assessment, Contours显示有关)
  typeId,
  // 经度
  lng,
  // 纬度
  lat,
  // 当前地图的唯一标识
  id,
  // 接口需要，用来获取统计数据(Statistics模块)
  suburbId,
  // 详情页自带的学校数据
  schools,
  // 是否suburbpage，用来判断是否动态获取学校数据
  isSuburb = false,
  // propertyId和houseId用来动态获取学校数据(比如房源详情页)
  propertyId,
  houseId,
  // 是否village，用来判断是否显示Flood assessment,Contours和Statistics模块
  isVillage = false,
  className
}) {

  const [currentMenu, setCurrentMenu] = useState(null)
  const [isRural, showMenu, isSchool, isCommute, isUnitaryPlan, isServices, isFlood, isContour, isStatistics] = useMemo(() => {
    return [
      typeId === HOUSE_TYPE_ID.rural,
      currentMenu === null,
      currentMenu === MENU_ITEM_TYPE.school,
      currentMenu === MENU_ITEM_TYPE.commute,
      currentMenu === MENU_ITEM_TYPE.unitaryPlan,
      currentMenu === MENU_ITEM_TYPE.services,
      currentMenu === MENU_ITEM_TYPE.flood,
      currentMenu === MENU_ITEM_TYPE.contour,
      currentMenu === MENU_ITEM_TYPE.statistics
    ]
  }, [typeId, currentMenu])

  const { map } = useMapboxContext()
  useEffect(() => {
    if (!map) return

    if (showMenu) {
      map.scrollZoom.disable()
    } else {
      map.scrollZoom.enable()
    }
  }, [showMenu, map])

  const { setCommonData } = useAboutAreaContext()
  useEffect(() => {
    setCommonData(d => ({ ...d, currentMenu }))
  }, [currentMenu, setCommonData])

  return (
    <div className={className}>
      <AboutAreaMenuControlContext.Provider value={{
        setCurrentMenu,
        isRural,
        hasCensus,
        regionId,
        lng,
        lat,
        id,
        suburbId,
        schools,
        isSuburb,
        propertyId,
        houseId
      }}>
        <AboutAreaMenu isVillage={isVillage} className={classNames({ '!hidden': !showMenu })}></AboutAreaMenu>
        {
          isSchool && <AboutAreaSchool></AboutAreaSchool>
        }
        {
          isCommute && <AboutAreaCommute></AboutAreaCommute>
        }
        {
          isUnitaryPlan && <AboutAreaUnitaryPlan></AboutAreaUnitaryPlan>
        }
        {
          isServices && <AboutAreaServices></AboutAreaServices>
        }
        {
          isContour && <AboutAreaContour></AboutAreaContour>
        }
        {
          isFlood && <AboutAreaFlood></AboutAreaFlood>
        }
        {
          isStatistics && <AboutAreaStatistics></AboutAreaStatistics>
        }
      </AboutAreaMenuControlContext.Provider>
    </div>
  )
}